import { render, staticRenderFns } from "./SurveyApp.vue?vue&type=template&id=0a4244c6"
import script from "./SurveyApp.vue?vue&type=script&lang=js"
export * from "./SurveyApp.vue?vue&type=script&lang=js"
import style0 from "./SurveyApp.vue?vue&type=style&index=0&id=0a4244c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports